/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { withFormik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import sha1 from 'sha1'
import { Form as FormUi, Container, Button, Label, Modal, Grid } from 'semantic-ui-react';
import MyRole from '../../apiInputComponent/myRole';
import MyBranchMultiple from '../../apiInputComponent/myBranchMultiple';
import patchAxios from '../../axiosComponent/patch';
import MyBusinessCategory from '../../apiInputComponent/myBusinessCategory';
import cogoToast from 'cogo-toast'
import MyvehicleNumber from '../../apiInputComponent/myVehicleNo';
import BatteryStatusDropDown from './Component/batteryStatusDropdown';
import { getBatteryStatus } from './batteryActions';



const EditBatteryInventory = ({ values, errors, touched, isSubmitting, handleSubmit, handleClose }) => {
  const [batteryStatus, setBatteryStatus] = useState()
  useEffect(() => {
    let batteryStatus = getBatteryStatus()
    batteryStatus.then((resp) => {
      setBatteryStatus(resp.resultSet)
    }).catch((err) => {

    })
  }, [])
  return (
    <>
      <Modal.Header>{'Edit Battery Inventory'}</Modal.Header>
      <Modal.Content>
        <Container>
          <div className="ui form">
            <Grid>
              <Grid.Column>
                <FormUi.Field>
                  <label className="labelName p-bold-600">Battery Code</label>
                  <Fieldmik name="batteryCode" placeholder="Battery Code" />
                  {touched.serialNo && errors.serialNo ? <Label size="mini" prompt pointing>{errors.serialNo}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column>
                <FormUi.Field>
                  <label className="labelName p-bold-600">Battery Serial No *</label>
                  <Fieldmik name="batterySerialNo" placeholder="Battery Serial No" />
                  {touched.batterySerialNo && errors.batterySerialNo ? <Label size="mini" prompt pointing>{errors.batterySerialNo}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
            </Grid>
            {/* <Grid>
              <Grid.Column>
                <FormUi.Field>
                  <label className="labelName p-bold-600">Vehicle No</label>
                  <Fieldmik component={MyvehicleNumber} name="vehicleNumber" placeholder="Vehicle No" />
                  {touched.tyrePositionId && errors.tyrePositionId ? <Label size="mini" prompt pointing>{errors.tyrePositionId}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
            </Grid> */}
            <Grid>
              <Grid.Column>
                <FormUi.Field>
                  <label className="labelName p-bold-600">Battery Status *</label>
                  <Fieldmik value={values.batteryStatusId}component={BatteryStatusDropDown} batteryStatusData={batteryStatus} name="batteryStatusId" />
                  {touched.batteryStatusId && errors.batteryStatusId ? <Label size="mini" prompt pointing>{errors.batteryStatusId}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
            </Grid>
          </div>
        </Container>
      </Modal.Content>
      <Modal.Actions>
        <Button disabled={isSubmitting} onClick={handleClose} size="tiny">Cancel</Button>
        <Button disabled={isSubmitting} onClick={handleSubmit} type="submit" size="tiny" primary>Submit</Button>
      </Modal.Actions>
    </>
  )
}

const FormikEditBatteryInventory = withFormik({
  mapPropsToValues(props) {

    return {
      batteryCode: props.branchArray.batteryCode || '',
      batteryStatusId: props.branchArray.batteryStatusId|| '',
      batterySerialNo: props.branchArray.batterySerialNo || '',
      VehicleNo: props.branchArray.VehicleId || '',
      batteryId:props.branchArray.batteryId || '',
      batteryStatus:props.branchArray.batteryStatus || ''
    }
  },

  validationSchema: yup.object().shape({
    // roleId: yup.string().required('Role Required'),
    batteryCode: yup.mixed(),
    batteryStatusId: yup.string().required('Battery Status Required'),
    batterySerialNo: yup.string().required(' Battery Serial No required')
  }),



  handleSubmit(values, { setErrors, setSubmitting, setSuccess }) {
    console.log("submit button is getting triggered", values)
    setSubmitting(true)
    let batteryCode = values.batteryCode
    let batteryStatusId = values.batteryStatusId
    let batterySerialNo = values.batterySerialNo
    let batteryId = values.batteryId
   

    patchAxios({
      url: `masters/battery/${batteryId}`,
      createItems: {
        'batteryCode': batteryCode,
        'batteryStatusId': batteryStatusId,
        'batterySerialNo': batterySerialNo
      }
    }).then
      ((data) => {
        console.log(data, 'dataaa')
        if (data.data.status == 200) {
          cogoToast.success(data.data.message)
          setTimeout(() => {
            window.location.href = "/battery-inventory"
          }, 1000);

          setSubmitting(false)
        } else if (data.data.status == 204) {
          cogoToast.error(data.data.message)
          setSubmitting(false)
        }
        else {
          cogoToast.error(data.message)
          setSubmitting(false)
        }
      })

  }
})(EditBatteryInventory)

export default FormikEditBatteryInventory
